'use client'; // Required for Next.js App Router

import { isValidImageSrc } from '@/app/utils/isValidImageSrc';

interface ImageLoaderParams {
  src: string;
  width: number;
  quality?: number;
}

const TRANSPARENT_PIXEL =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

export default function awsLambdaLoader({ src, width, quality }: ImageLoaderParams): string {
  if (!isValidImageSrc(src)) return TRANSPARENT_PIXEL;

  try {
    const url = new URL(src);
    url.searchParams.set('w', width.toString());
    url.searchParams.set('q', (quality || 75).toString());
    url.searchParams.set('ext', 'webp');
    return url.toString();
  } catch {
    const separator = src.includes('?') ? '&' : '?';
    const params = new URLSearchParams({
      w: width.toString(),
      q: (quality || 75).toString(),
      ext: 'webp',
    });
    return `${src}${separator}${params.toString()}`;
  }
}
